import BIRDS from 'vanta/dist/vanta.birds.min';
import * as THREE from 'three';

const birds = () => {
  const target = document.querySelector('.birds-bg');

  if (target) {
    const body = document.querySelector('body');
    let bgColor = '#28282A';
    let birdColor = '#c6d1c3';

    if (body.classList.contains('investor')) {
      bgColor = '#F7F410';
      birdColor = '#000000';
    }

    BIRDS({
      THREE,
      el: '.birds-bg',
      mouseControls: true,
      touchControls: true,
      gyroControls: false,
      minHeight: 200.00,
      minWidth: 200.00,
      scale: 1.00,
      scaleMobile: 1.00,
      backgroundColor: bgColor,
      color1: birdColor,
      color2: 0x0,
      birdSize: 0.40
    });
  }
};

export default birds;
